import { render, staticRenderFns } from "./dialog-form.vue?vue&type=template&id=d42eaf64"
import script from "./dialog-form.vue?vue&type=script&lang=js"
export * from "./dialog-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d42eaf64')) {
      api.createRecord('d42eaf64', component.options)
    } else {
      api.reload('d42eaf64', component.options)
    }
    module.hot.accept("./dialog-form.vue?vue&type=template&id=d42eaf64", function () {
      api.rerender('d42eaf64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/email-bulk-message/dialog-form.vue"
export default component.exports